import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { ScreeningPackageConstants } from '@uzurv/dots';

@Component({
  selector: 'app-create-random-substance-screening-dialog',
  templateUrl: './create-random-substance-screening-dialog.component.html',
  styleUrls: ['./create-random-substance-screening-dialog.component.scss']
})
export class CreateRandomSubstanceScreeningDialogComponent {
  formGroup: FormGroup;
  screeningPackageCodes = ScreeningPackageConstants;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<CreateRandomSubstanceScreeningDialogComponent>
  ) {
    this.formGroup = this.fb.group({
      testType: [null, Validators.required]
    });
  }

  handleOrderClicked() {
    const dialogResult: any = {
      testType: this.formGroup.get('testType').value
    };
    this.dialogRef.close(dialogResult);
  }

  handleClose(): void {
    this.dialogRef.close();
  }
}
